import axiosInstance from 'Api';

const organisationList = ()=>{
    return axiosInstance.get('organisation-link');
}

const saveOrganisationLink = (formData) => {
    return axiosInstance.post('organisation-link/save', formData);
};

const updateOrganisationLink = (formData)=>{
    return axiosInstance.post('organisation-link/update', formData);
}

const communityIdList = ()=>{
    return axiosInstance.get('organisation-link/community-list');
}

const deleteOrganisationLink = (id)=>{
    return axiosInstance.get(`organisation-link/delete/${id}`);
}

const powerBiApi = (data)=>{
    return axiosInstance.post("power-bi/update", data)
}

const communityList = ()=>{
    return axiosInstance.get("power-bi/community-lists")
}
const endpoinList = ()=>{
    return axiosInstance.get("power-bi/endpoints-list")
}

const smsYears = ()=>{
    return axiosInstance.get("site-years")
}
const smsStatistics = (year)=>{
    return axiosInstance.get(`get-sms-statistics?year=${year}`)
}

const getQR = (iAdminId) => {
    return axiosInstance.get(`2fa/generateQRCode?iAdminId=${iAdminId}`);
}

const postQRCode = (qrCode) => {
    return axiosInstance.post("2fa/enable", qrCode);
}

const disable2FA = (data) => {
    return axiosInstance.post("2fa/disable", data);
}
const handleEmailLink=()=>{
     return axiosInstance.post("send-email-code");
}
const disableEmailCode=()=>{
    return axiosInstance.get('2fa/send-disable-email-code')
}
const VerifyDisableEmail=(code)=>{
   return axiosInstance.post('2fa/verify-disable-email-code',code)
}
const SendEmailCode=()=>{
    return axiosInstance.post('send-email-code')
}
const testEmailOrSms = (data) => {
    return axiosInstance.post("test-emails-or-sms", data);
};

const AdminService = {
    organisationList,
    saveOrganisationLink,
    updateOrganisationLink,
    communityIdList,
    deleteOrganisationLink,
    powerBiApi,
    communityList,
    endpoinList,
    smsYears,
    smsStatistics,
    getQR,
    postQRCode,
    disable2FA,
    handleEmailLink,
    disableEmailCode,
    VerifyDisableEmail,
    SendEmailCode,
    testEmailOrSms
};
export default AdminService;